import email from "@/router/email";
import tickets from "@/router/tickets";
import settings from "@/router/settings";
import servers from "@/router/servers";
import clouds from "@/router/clouds";
import users from "@/router/users";
import vpc from "@/router/vpc";
import notifications from "@/router/notifications";
import billing from "@/router/billing";
import kubernetes from "@/router/kubernetes";

const routes = [
    {
        path: '/',
        name: 'index',
        component: () => import('@/pages/Index/IndexPage.vue'),
        meta: {
            requiresAuth: true,
            layout: 'content',
            title: 'basics.main_page',
        }
    },
    {
        path: '/github-sign-in',
        name: 'impersonate',
        component: () => import('@/pages/Index/GithubSignInPage.vue'),
        meta: {
            requiresAuth: false,
            layout: 'blank',
            title: 'basics.redirecting',
        }
    },

    {
        path: '/settings/profile/github',
        name: 'impersonate2',
        component: () => import('@/pages/Index/GithubLinkPage.vue'),
        meta: {
            requiresAuth: false,
            layout: 'blank',
            title: 'basics.redirecting',
        }
    },
    {
        path: '/token/impersonate',
        name: 'token-impersonate',
        component: () => import('@/pages/Index/ImpersonatePage.vue'),
        meta: {
            requiresAuth: false,
            layout: 'blank',
            title: 'basics.redirecting',
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/pages/Index/LoginPage.vue'),
        meta: {
            requiresAuth: false,
            layout: 'base',
            title: 'pages.login.title',
        }
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('@/pages/Index/RegisterPage.vue'),
        meta: {
            requiresAuth: false,
            layout: 'navbar',
            title: 'pages.register.title',
        }
    },
    ...email,
    ...tickets,
    ...settings,
    ...servers,
    ...clouds,
    ...vpc,
    ...users,
    ...notifications,
    ...billing,
    ...kubernetes,
    {
        path: '/complete-registration',
        name: 'complete_registration',
        component: () => import('@/pages/Index/CompleteRegistration.vue'),
        meta: {
            requiresAuth: true,
            layout: 'content',
            title: "components.complete.title",
        }
    },
    {
        path: '/:project_id/quotas',
        name: 'vpc.quotas',
        component: () => import('@/pages/Index/QuotasPage.vue'),
        meta: {
            requiresAuth: true,
            layout: 'content',
            title: "Quotas",
        }
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/pages/Index/DashboardPage.vue'),
        meta: {
            requiresAuth: true,
            layout: 'content',
            title: "Dashboard",
        }
    },
    {
        path: '/one-id/impersonate',
        name: 'impersonate',
        component: () => import('@/pages/Index/ImpersonatePage.vue'),
        meta: {
            requiresAuth: false,
            layout: 'navbar',
            title: "Login One ID",
        }
    },
    {
        path: '/design/:id',
        name: 'design.edit',
        component: () => import('@/pages/Index/DesignPage.vue'),
        meta: {
            requiresAuth: true,
            need_project: true,
            layout: 'content',
            title: "Dashboard",
        }
    },
]

export default routes